import useStyles from './styles'

const DEFAULT = 'No type'

const UserType = ({ client }) => {
  const classes = useStyles()

  if (!client.type?.name) {
    return <div className={classes.root}>{DEFAULT}</div>
  }

  return <div className={classes.root}>{client.type?.name}</div>
}

export default UserType
